import React from 'react';
import PropTypes from 'prop-types';
import compose from '../../../hoc/compose';
import displayNames from '../../displayNames';
import Checkbox from '../../checkbox';

var DropDownCheckboxContainer = function DropDownCheckboxContainer(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: props.className,
    onClick: function onClick(e) {
      //Workaround to solve on click twice
      if (e.target.type !== 'checkbox') {
        e.stopPropagation();
      }
    }
  }, /*#__PURE__*/React.createElement(Checkbox, {
    onChange: function onChange() {},
    value: props.selected,
    disabled: props.disabled
  }));
};

DropDownCheckboxContainer.propTypes = {
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string
};
DropDownCheckboxContainer.DisplayName = displayNames.DROP_DOWN_CHECKBOX_CONTAINER;
export default compose(DropDownCheckboxContainer);